import { Resolver, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useSelector } from 'react-redux';
import { validationSchema } from '../validationSchema';
import { getInitialValues } from '../utils';
import { useMemo } from 'react';
import { TManagmentStructure } from '../types';
import { cloneDeep } from 'lodash';
import { selectManagmentStructure } from '~/store/identification-form/selectors';

export const useManagmentStructureForm = () => {
  const formData = useSelector(selectManagmentStructure);

  const initialValues = useMemo(() => getInitialValues(formData as TManagmentStructure), []);

  const form = useForm({
    resolver: yupResolver(validationSchema) as unknown as Resolver<TManagmentStructure>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldUnregister: false,
    defaultValues: cloneDeep(initialValues),
  });

  return form;
};
